import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { IMG } from "../common/CONST"
import { RequestPopUp } from "../common/element/RequestPopUp"
import { ClientInnPopUpList } from "./inn/ClientInnPopUpList"
import { CurrencyPayerPopUpList } from "./currencyPayer/CurrencyPayerPopUpList"
import { CURRENCY_REPLENISHMENT_NEW_ROUTE, ORDER_NEW_ROUTE, REPLENISHMENT_NEW_ROUTE } from "../../routes"
import { CurrencyRequestPopUp } from "../common/element/CurrencyRequestPopUp"

export const ClientQuickActions = () => {
  const navigate = useNavigate()

  const [showInn, setShowInn] = useState(false)
  const [showCurrencyPayer, setShowCurrencyPayer] = useState(false)
  const [showRequest, setShowRequest] = useState(false)
  const [showCurrencyRequest, setShowCurrencyRequest] = useState(false)

  return (
    <>
      <section className="quick-actions">
        <div className="quick-action-block" onClick={() => setShowInn(true)}>
          <div className="quick-action-icon">
            <img src={IMG.companies} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Рублевый плательщик</p>
        </div>
        <div className="quick-action-block" onClick={() => setShowCurrencyPayer(true)}>
          <div className="quick-action-icon">
            <img src={IMG.companies} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Валютный плательщик</p>
        </div>
        <div className="quick-action-block" onClick={() => setShowRequest(true)}>
          <div className="quick-action-icon">
            <img src={IMG.requests} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Создать рублевый запрос</p>
        </div>
        <div className="quick-action-block" onClick={() => setShowCurrencyRequest(true)}>
          <div className="quick-action-icon">
            <img src={IMG.requests} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Создать валютный запрос</p>
        </div>
        <div className="quick-action-block" onClick={() => navigate(REPLENISHMENT_NEW_ROUTE)}>
          <div className="quick-action-icon">
            <img src={IMG.deals} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Создать рублевое пополнение</p>
        </div>
        <div className="quick-action-block" onClick={() => navigate(CURRENCY_REPLENISHMENT_NEW_ROUTE)}>
          <div className="quick-action-icon">
            <img src={IMG.deals} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Создать валютное пополнение</p>
        </div>
        <div className="quick-action-block" onClick={() => navigate(ORDER_NEW_ROUTE)}>
          <div className="quick-action-icon">
            <img src={IMG.orders} alt="" className="header-chapter-img" />
          </div>
          <p className="quck-action-text">Создать ордер</p>
        </div>
      </section>

      <RequestPopUp visible={showRequest} setVisible={setShowRequest} />
      <CurrencyRequestPopUp visible={showCurrencyRequest} setVisible={setShowCurrencyRequest} />
      <CurrencyPayerPopUpList visible={showCurrencyPayer} setVisible={setShowCurrencyPayer} />
      <ClientInnPopUpList visible={showInn} setVisible={setShowInn} />
    </>
  )
}
